'use client';
import { createPaletteChannel } from 'minimal-shared/utils';

import COLORS_INFOR from './core/colors-app-inforcfc.json';
import COLORS_MINHACNH from './core/colors-app-minhacnh.json';
import type { ThemeOptions } from './types';

// ----------------------------------------------------------------------

export const appInforcfcTheme: ThemeOptions = {
  colorSchemes: {
    light: {
      palette: {
        primary: createPaletteChannel(COLORS_INFOR.primary),
      },
    },
    dark: {
      palette: {
        primary: createPaletteChannel(COLORS_INFOR.primary),
      },
    },
  },
};

export const appMinhacnhTheme: ThemeOptions = {
  colorSchemes: {
    light: {
      palette: {
        primary: createPaletteChannel(COLORS_MINHACNH.primary),
        secondary: createPaletteChannel(COLORS_MINHACNH.secondary),
      },
    },
    dark: {
      palette: {
        primary: createPaletteChannel(COLORS_MINHACNH.primary),
        secondary: createPaletteChannel(COLORS_MINHACNH.secondary),
      },
    },
  },
};
